import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

export type PerfromanceWidgetType = {
    scriptLoaded: boolean;
};

const initialState: PerfromanceWidgetType = {
    scriptLoaded: false,
};

const reducer = {
    "Custom/PerformanceWidget/SetScriptLoaded": (
        draft: Draft<PerfromanceWidgetType>,
        action: { scriptLoaded: boolean },
    ) => {
        draft.scriptLoaded = action.scriptLoaded;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
